/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';

import { getGlobalLetterTemplate } from '../api';

export const useGetGlobalLetterTemplate = () => {
  const globalLetterQuery = useQuery<any[]>({
    queryKey: ['globalLetterTemplates'],
    // @ts-expect-error malformed data
    queryFn: getGlobalLetterTemplate,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return globalLetterQuery;
};
